const tr = {
  appointmentTags:{
    attributes:{
      id:                   'Id',
      name:                 'Nome',
      created_at:           'Criado em',
      updated_at:           'Atualizado em',
      categories:           'Categorias',
    },
    extras:{
      create_appointment_tag: 'Novo Sintoma',
      edit_appointment_tag: 'Editando Sintoma',
      show_appointment_tag: 'Visualizando Sintoma',
    },
    defSingular: 'Sintoma',
    defPlural: 'Sintomas',
  }
};

export default tr;
